// src/db/userDB.js
import Dexie from 'dexie'

// 1️⃣ 创建数据库实例
export const db = new Dexie('UserDB')

// 2️⃣ 定义表结构（相当于表和字段）
db.version(1).stores({
    users: '++id, id, type, email, customerName, contactName, customerCode, zoneAddress,zoneCode'
    // customerTypeId 作为主键
})

// 3️⃣ 封装操作方法
export const UserTable = {
    // 添加单个
    async add(user) {
        return await db.users.put(user)
    },

    async upsertByEmail(user) {
        const email = (user?.email || '').trim()
        if (!email) return
        const normalizedEmail = email.toLowerCase()
        // 先检查是否已存在相同 email 的记录
        const existing = await db.users.where('email').equals(normalizedEmail).first()
        const id = existing?.id || Date.now() + Math.random().toString(36).slice(2, 11)
        const payload = {
            ...user,
            email: normalizedEmail,
            id
        }
        return await db.users.put(payload)
    },

    async deleteByEmail(email) {
        const normalizedEmail = (email || '').trim().toLowerCase()
        if (!normalizedEmail) return
        const records = await db.users.where('email').equals(normalizedEmail).toArray()
        if (records.length) {
            const ids = records.map(it => it.id)
            return await db.users.bulkDelete(ids)
        }
    },

    // 批量添加
    async bulkAdd(list) {
        // 注意要去掉响应式对象
        const pureList = JSON.parse(JSON.stringify(list))
        return await db.users.bulkPut(pureList)
    },

    // 查询所有
    async getAll() {
        return await db.users.toArray()
    },

    // 按 id 查询
    async getById(id) {
        return await db.users.get(id)
    },

    // 删除指定 id
    async deleteById(id) {
        return await db.users.delete(id)
    },

    async deleteByEmail(email) {
        const normalizedEmail = (email || '').trim().toLowerCase()
        if (!normalizedEmail) return
        const records = await db.users.where('email').equals(normalizedEmail).toArray()
        if (records.length) {
            const ids = records.map(it => it.id)
            return await db.users.bulkDelete(ids)
        }
    },

    // 清空表
    async clear() {
        return await db.users.clear()
    },

    // 分页查询
    // 分页查询，同时返回总条数
    async getPageWithTotal(page = 1, pageSize = 20) {
        const total = await db.users.count()
        const totalPages = Math.max(1, Math.ceil(total / pageSize))

        // 保证 page 在合法范围内
        const validPage = Math.min(Math.max(1, page), totalPages)
        const offset = (validPage - 1) * pageSize

        // 注意：必须先 orderBy 或 toCollection 才能使用 offset/limit
        const data = await db.users
            .orderBy('id')               // 或者使用 .toCollection() 根据需要
            .offset(offset)
            .limit(pageSize)
            .toArray()

        return {
            data,
            total,
            page: validPage,
            pageSize,
            totalPages
        }
    }
}